<template>
  <section class="voting-contest" :aria-labelledby="`contest-${contest.key}`">
    <header class="voting-contest__header">
      <div>
        <p class="voting-contest__scope">{{ contest.scope || "Votación" }}</p>
        <h2 :id="`contest-${contest.key}`" class="voting-contest__title">
          {{ contest.title }}
        </h2>
      </div>
      <span class="voting-contest__counter">
        {{ selectedCount }} / {{ contest.maxSelections }}
      </span>
    </header>

    <p v-if="contest.description" class="voting-contest__description">
      {{ contest.description }}
    </p>
    <p class="voting-contest__instruction">
      <template v-if="contest.selectionMode === 'SINGLE'">
        Selecciona una opción.
      </template>
      <template v-else-if="contest.selectionMode === 'RANKED'">
        Selecciona las opciones en el orden de preferencia.
      </template>
      <template v-else>
        Selecciona hasta {{ contest.maxSelections }} opciones.
      </template>
      <span v-if="contest.allowAbstention"> También puedes abstenerte.</span>
    </p>

    <div
      class="voting-contest__options"
      :role="allowsMultiple ? 'group' : 'radiogroup'"
      :aria-label="contest.title"
    >
      <VotingOption
        v-for="option in contest.options"
        :key="option.key"
        :option="option"
        :selected="isSelected(option)"
        :selection-mode="contest.selectionMode"
        @select="selectOption(option)"
      />
    </div>

    <button
      v-if="contest.allowAbstention"
      type="button"
      class="voting-contest__clear"
      :disabled="selectedCount === 0"
      @click="abstain"
    >
      Limpiar selección y abstenerme
    </button>
  </section>
</template>

<script>
import VotingOption from "./VotingOption.vue";

export default {
  name: "VotingContest",
  components: { VotingOption },
  props: {
    contest: { type: Object, required: true },
    value: { type: [String, Array], default: "" },
  },
  computed: {
    selectionKeys() {
      if (this.contest.selectionMode === "SINGLE") {
        return this.value ? [this.value] : [];
      }
      return Array.isArray(this.value) ? this.value : [];
    },
    selectedCount() {
      return this.selectionKeys.length;
    },
    allowsMultiple() {
      return this.contest.selectionMode !== "SINGLE";
    },
  },
  methods: {
    selectOption(option) {
      if (!this.allowsMultiple) {
        this.$emit("input", option.key);
        return;
      }

      const next = this.selectionKeys.slice();
      const index = next.indexOf(option.key);
      if (index >= 0) next.splice(index, 1);
      else if (next.length < this.contest.maxSelections) next.push(option.key);
      this.$emit("input", next);
    },
    abstain() {
      this.$emit("input", this.allowsMultiple ? [] : "");
    },
    isSelected(option) {
      return this.selectionKeys.includes(option.key);
    },
  },
};
</script>

<style scoped>
.voting-contest {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.voting-contest__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.voting-contest__scope {
  margin: 0;
  color: #a66f00;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.voting-contest__title {
  margin: 5px 0 0;
  color: #1b273e;
  font-size: 21px;
  line-height: 1.3;
}

.voting-contest__counter {
  flex: 0 0 auto;
  padding: 6px 10px;
  border-radius: 999px;
  background: #f1f4f8;
  color: #687386;
  font-size: 12px;
  font-weight: 800;
  white-space: nowrap;
}

.voting-contest__description,
.voting-contest__instruction {
  margin: 0;
  color: #687386;
  font-size: 14px;
  line-height: 1.6;
}

.voting-contest__instruction {
  font-size: 13px;
}

.voting-contest__options {
  display: grid;
  gap: 12px;
}

.voting-contest__clear {
  align-self: flex-start;
  min-height: 40px;
  padding: 8px 0;
  border: 0;
  background: transparent;
  color: #1b273e;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.voting-contest__clear:disabled {
  color: #aeb6c2;
  cursor: not-allowed;
}
</style>
